import { render, staticRenderFns } from "./PanelManager.vue?vue&type=template&id=32308dea&scoped=true"
import script from "./PanelManager.vue?vue&type=script&lang=js"
export * from "./PanelManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32308dea",
  null
  
)

export default component.exports